import { configureDarkTheme } from './dark';
import { configureLightTheme } from './light';

export function setupCustomThemesForAce(ace: AceAjax.Ace): void {
  configureDarkTheme(ace);
  configureLightTheme(ace);
}
